import type { ITooltipTheme } from '@visactor/vchart';

export const tooltip: ITooltipTheme = {
  panel: {
    backgroundColor: 'rgba(0,0,0,0.8)'
  },
  titleLabel: {
    fontColor: 'rgba(255,255,255,0.65)'
  },
  keyLabel: {
    fontColor: 'rgba(255,255,255,0.65)'
  },
  valueLabel: {
    fontColor: 'rgba(255,255,255,0.65)'
  }
};
